/* eslint-disable sort-imports */
import Vue from 'vue';
import Router from 'vue-router';

// 向下兼容问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
    if(onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

import Layout from '@/layout';
import adminRouter from './modules/admin';
import messageRouter from './modules/message';
import homeRouter from "./modules/home";
import dynamicRouter from "./modules/dynamic";
import mailListRouter from "./modules/mailList";
import administrativeRouter from "./modules/administrative";
import financeRouter from "./modules/finance";
import legalRouter from "./modules/legal";
import saleRouter from "./modules/sale";
import resourceRouter from "./modules/resource";
import customerRouter from "./modules/customer";
import engineerRouter from "./modules/engineer";
import crmRouter from "./modules/crm";
import tgzRouter from "./modules/tgz";


/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    isDetail: true               是否直接从待办事项调转到详情
  }
 */

export const constantRouterMap = [
    {
        path: '/manageCenter',
        component: Layout,
        children: [
            ...homeRouter,
            {
                path: '/user',
                name: 'User',
                hidden: true,
                component: () => import('@/views/user/index'),
                meta: {
                    title: '个人信息设置'
                }
            },
            {
                path: '/notice/:id',
                hidden: true,
                meta: { white: true, activeMenu: '/index' },
                component: () => import('@/views/home/notice')
            }
        ]
    },
    // 首页 - 登录页
    {
        path: '/',
        hidden: true,
        meta: { white: true },
        component: () => import('@/views/home/home')
    },
    // platform登录
    {
        path: '/platform',
        name: 'Platform',
        hidden: true,
        meta: { white: true },
        component: () => import('@/views/home/otherLogin/platformLogin')
    },
    // 地图分享
    {
        path: '/mapShare/:tenantId/:key',
        hidden: true,
        meta: { white: true },
        component: () => import('@/views/mapShare/index')
    },
    {
        path: '/401',
        hidden: true,
        meta: { white: true },
        component: () => import('@/views/errorPage/401')
    },
    {
        path: '/404',
        hidden: true,
        meta: { white: true },
        component: () => import('@/views/errorPage/building')
    }
];

export const developRouterMap = [
    // icon
    {
        path: '/icon',
        hidden: true,
        meta: { white: true },
        component: () => import('@/views/icons/index')
    }
];

export const asyncRouterMap = [
    // 后台
    ...adminRouter,
    messageRouter,
    // 动态
    dynamicRouter,
    // 通讯录
    mailListRouter,
    // 行政
    administrativeRouter,
    // 财务
    financeRouter,
    // 客户
    crmRouter,
    // 法务
    legalRouter,
    // 销售
    saleRouter,
    // 资源
    resourceRouter,
    // 客服
    customerRouter,
    // 工程
    engineerRouter,
    // 第三方任务
    tgzRouter,
    { path: '*', redirect: '/404', hidden: true }
];

const createRouter = () => new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: process.env.NODE_ENV != "development" ? constantRouterMap : [...constantRouterMap, ...developRouterMap]
});

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

export default router;


